// extracted by mini-css-extract-plugin
export default {"button":"buttons_button__5PiIG","linkButton":"buttons_linkButton__muwCp"};